/** Pages by address, without reloading: /league, /league/ogreclan/draft, /plan, /account */
import type { ComponentChildren, JSX } from 'preact';
import { useEffect, useState } from 'preact/hooks';

export function navigate(to: string, replace = false) {
	if (to === location.pathname + location.search) return;
	if (replace) history.replaceState(null, '', to);
	else history.pushState(null, '', to);
	dispatchEvent(new PopStateEvent('popstate'));
	window.scrollTo(0, 0);
}

export function usePath() {
	const [path, setPath] = useState(location.pathname);
	useEffect(() => {
		const update = () => setPath(location.pathname);
		addEventListener('popstate', update);
		return () => removeEventListener('popstate', update);
	}, []);
	return path;
}

type LinkProps = JSX.HTMLAttributes<HTMLAnchorElement> & { href: string, children?: ComponentChildren };

/** A link to another page of the app (an ordinary link for new tabs and the like) */
export function Link({ href, children, ...rest }: LinkProps) {
	return <a href={href} {...rest} onClick={event => {
		if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
		event.preventDefault();
		navigate(href);
	}}>{children}</a>;
}
